module.exports = __webpack_public_path__ + "img/market.b0fb6f59.svg";